import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { AuthService } from '../services/auth.service';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { Cylinder } from '../models/cylinder';
import { Valve_Model } from '../models/valve_Model';
import { SnotifyService } from 'ng-snotify';

@Injectable()
export class CylinderStatusReportService {
  constructor(private http: HttpClient, private authService: AuthService, private snotifyService: SnotifyService) { }

  public getResults(page: Page, company_Id: number, location_Id: number, in_Service: string, created_From: string, created_To: string, show_All: boolean,
    cyl_Serial_Num: string, cyl_Size_Id: number, cyl_Material_Id: number, product_Type_Id: number, tag_Id: string, valve_Serial_Num: string, valve_Model_Num_Id: number,
    quick_Search: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Created_By'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&company_Id=' + company_Id
      params += '&location_Id=' + location_Id;
      params += '&in_Service=' + in_Service;
      params += '&created_From=' + moment(created_From).format('YYYY-MM-DD');
      params += '&created_To=' + moment(created_To).format('YYYY-MM-DD');
      params += '&show_All=' + show_All;
      params += '&cyl_Serial_Num=' + cyl_Serial_Num;
      params += '&cyl_Size_Id=' + cyl_Size_Id;
      params += '&cyl_Material_Id=' + cyl_Material_Id;
      params += '&cyl_Product_Type_Id=' + product_Type_Id;
      params += '&tag_Id=' + tag_Id;
      params += '&valve_Serial_Num=' + valve_Serial_Num;
      params += '&valve_Model_Num_Id=' + valve_Model_Num_Id;
      var is_Client = this.authService.currentUser.value.userType == 0;
      params += '&is_Client=' + is_Client;
      params += '&quick_Search=' + quick_Search;

      this.http.get<ServerData>(environment.apiUrl + 'cylinderStatus/GetTable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        console.log("Data Retrieved")
        console.log(data);
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });

    });
  }

  //Populate Filters
  public getAllCylinderSize(): Promise<Cylinder[]> {
    const headers = {
      'Content-Type': 'application/json',
    };

    return new Promise((resolve, reject) => {
      this.http.get<Cylinder[]>(environment.apiUrl + 'cylinderStatus/getAllCylinderSize', { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        resolve(null)
      });
    });
  }
  public getAllCylinderMaterial(): Promise<Cylinder[]> {
    const headers = {
      'Content-Type': 'application/json',
    };

    return new Promise((resolve, reject) => {
      this.http.get<Cylinder[]>(environment.apiUrl + 'cylinderStatus/getAllCylinderMaterial', { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        resolve(null)
      });
    });
  }
  public getAllValveModels(): Promise<Valve_Model[]> {
    const headers = {
      'Content-Type': 'application/json',
    };

    return new Promise((resolve, reject) => {
      this.http.get<Valve_Model[]>(environment.apiUrl + 'cylinderStatus/getAllValveModels', { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        resolve(null)
      });
    });
  }

  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }

  public generateExcelCylinders(company_Id: number, location_Id: number, in_Service: string, created_From: string, created_To: string, show_All: boolean,
    cyl_Serial_Num: string, cyl_Size_Id: number, cyl_Material_Id: number, product_Type_Id: number, tag_Id: string, valve_Serial_Num: string,
    valve_Model_Num_Id: number, quick_Search: string): Promise<any> {

    return new Promise((resolve, reject) => {

      let params = '?company_Id=' + company_Id
      params += '&location_Id=' + location_Id;
      params += '&in_Service=' + in_Service;
      params += '&created_From=' + moment(created_From).format('YYYY-MM-DD');
      params += '&created_To=' + moment(created_To).format('YYYY-MM-DD');
      params += '&show_All=' + show_All;
      params += '&cyl_Serial_Num=' + cyl_Serial_Num;
      params += '&cyl_Size_Id=' + cyl_Size_Id;
      params += '&cyl_Material_Id=' + cyl_Material_Id;
      params += '&cyl_Product_Type_Id=' + product_Type_Id;
      params += '&tag_Id=' + tag_Id;
      params += '&valve_Serial_Num=' + valve_Serial_Num;
      params += '&valve_Model_Num_Id=' + valve_Model_Num_Id;

      var is_Client = this.authService.currentUser.value.userType == 0;
      params += '&is_Client=' + is_Client;
      params += '&quick_Search=' + quick_Search;

      this.http.get<any>(environment.apiUrl + 'cylinderStatus/GetExcelCylinders' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public generateExcelReport(company_Id: number, location_Id: number, in_Service: string, created_From: string, created_To: string, show_All: boolean,
    cyl_Serial_Num: string, cyl_Size_Id: number, cyl_Material_Id: number, product_Type_Id: number, tag_Id: string, valve_Serial_Num: string, valve_Model_Num_Id: number): Promise<any> {

    return new Promise((resolve, reject) => {

      let params = '?company_Id=' + company_Id
      params += '&location_Id=' + location_Id;
      params += '&in_Service=' + in_Service;
      params += '&created_From=' + moment(created_From).format('YYYY-MM-DD');
      params += '&created_To=' + moment(created_To).format('YYYY-MM-DD');
      params += '&show_All=' + show_All;
      params += '&cyl_Serial_Num=' + cyl_Serial_Num;
      params += '&cyl_Size_Id=' + cyl_Size_Id;
      params += '&cyl_Material_Id=' + cyl_Material_Id;
      params += '&cyl_Product_Type_Id=' + product_Type_Id;
      params += '&tag_Id=' + tag_Id;
      params += '&valve_Serial_Num=' + valve_Serial_Num;
      params += '&valve_Model_Num_Id=' + valve_Model_Num_Id;

      var is_Client = this.authService.currentUser.value.userType == 0;
      params += '&is_Client=' + is_Client;

      this.http.get<any>(environment.apiUrl + 'cylinderStatus/GetExcelReport' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public archiveCylinder(quarantineState: Cylinder[]): Promise<Cylinder[]> {

    console.log(quarantineState);
    console.log(environment.apiUrl + 'FillBatchReport/UpdateFillBatchDetails');

    return new Promise((resolve, reject) => {
      this.http.post<Cylinder[]>(environment.apiUrl + 'cylinderStatus/ArchiveCylinder', quarantineState).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully Archived Cylinders');
      }, error => {
        this.snotifyService.success('Failed to Archive Cylinders: ' + error);
        console.log(error);
        reject();
      });
    });
  }

  public moveToMissingArea(cylinderId: number): Promise<any> {
    
    return new Promise((resolve, reject) => {
      this.http.post<any>(`${environment.apiUrl}cylinderStatus/MoveToMissingArea`, cylinderId ).subscribe(
        (data) => {
          this.snotifyService.success('Successfully Moved Cylinder to Missing Area');
          resolve(data);
        },
        (error) => {
          this.snotifyService.error('Failed to Move Cylinder To Missing Area: ' + error.message);
          console.error("Error details:", error);
          reject(error);
        }
      );
    });
  }

}
